import i18next from './i18nextLocales/i18n';

document.addEventListener('DOMContentLoaded', initPage);

function initPage() {
	validateFields();
}
const form = document.querySelectorAll('.form');
const fields = [];
form.forEach((field) => fields.push(field.querySelectorAll('.js-field:not(.nice-select)')));
// eslint-disable-next-line import/prefer-default-export
export function validateEmail(data) {
	const testData = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; // https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
	if (testData.test(data)) {
		return true;
	}
	return false;
}
export const generateError = function (text) {
	const error = document.createElement('span');
	error.classList.add('error');
	error.innerHTML = text;
	return error;
};

export const removeValidation = function () {
	const errors = [];
	form.forEach((field) => errors.push(field.querySelectorAll('label.error')));
	errors.filter((error) => error.forEach((errorItem) => {
		errorItem.remove();
	}));
};
export function checkFields(elForm) {
	const fieldsEl = [];
	fieldsEl.push(elForm.querySelectorAll('.js-field:not(.nice-select)'));
	fieldsEl.filter((field) => field.forEach((fieldName) => {
		if (fieldName.getAttribute('name') === 'email') {
			const status = fieldName.value;
			const error = generateError('');
			if (fieldName.parentElement.querySelector('.error') == null) {
				fieldName.parentElement.prepend(error);
			}
			if (status.length <= 0) {
				// eslint-disable-next-line no-param-reassign
				fieldName.parentElement.querySelector('.error').innerHTML = i18next.t('empty_field');
				fieldName.parentElement.classList.add('form__box_error');
				fieldName.parentElement.classList.remove('form__box_valid');
				return false;
			}
			if (!validateEmail(status)) {
				// eslint-disable-next-line no-param-reassign
				fieldName.parentElement.querySelector('.error').innerHTML = i18next.t('wrong_email');
				fieldName.parentElement.classList.add('form__box_error');
				fieldName.parentElement.classList.remove('form__box_valid');
				return false;
			}
			if (fieldName.parentElement.querySelector('.error') !== null) {
				fieldName.parentElement.querySelector('.error').remove();
			}
			fieldName.parentElement.classList.remove('form__box_error');
			fieldName.parentElement.classList.add('form__box_valid');
			return true;
		}
		if (fieldName.getAttribute('name') === 'agree' || fieldName.getAttribute('name') === 'checkbox') {
			const status = fieldName;
			const error = generateError('');
			if (fieldName.parentElement.querySelector('.error') == null) {
				fieldName.parentElement.prepend(error);
			}
			if (!status.checked === true) {
				// eslint-disable-next-line no-param-reassign
				fieldName.parentElement.querySelector('.error').innerHTML = i18next.t('privacy_policy');
				fieldName.parentElement.classList.add('form__box_error');
				fieldName.parentElement.classList.remove('form__box_valid');
				return false;
			}
			if (fieldName.parentElement.querySelector('.error') !== null) {
				fieldName.parentElement.querySelector('.error').remove();
			}
			fieldName.parentElement.classList.remove('form__box_error');
			fieldName.parentElement.classList.add('form__box_valid');
			return true;
		}
		if (fieldName.getAttribute('name') === 'phone') {
			const status = fieldName.value;
			const error = generateError('');
			if (fieldName.parentElement.querySelector('.error') == null) {
				fieldName.parentElement.prepend(error);
			}
			if (status.length <= 0) {
				// eslint-disable-next-line no-param-reassign
				fieldName.parentElement.querySelector('.error').innerHTML = i18next.t('empty_field');
				fieldName.parentElement.classList.add('form__box_error');
				fieldName.parentElement.classList.remove('form__box_valid');
				return false;
			}
			if (status.length < 19) {
				// eslint-disable-next-line no-param-reassign
				fieldName.parentElement.querySelector('.error').innerHTML = i18next.t('wrong_tel');
				fieldName.parentElement.classList.add('form__box_error');
				fieldName.parentElement.classList.remove('form__box_valid');
				return false;
			}
			if (fieldName.parentElement.querySelector('.error') !== null) {
				fieldName.parentElement.querySelector('.error').remove();
			}
			fieldName.parentElement.classList.remove('form__box_error');
			fieldName.parentElement.classList.add('form__box_valid');
			return true;
		}
		if (fieldName.getAttribute('name') === 'select' || fieldName.getAttribute('name') === 'order_type_id') {
			const status = fieldName.selectedIndex;
			const error = generateError('');
			if (fieldName.closest('.form__box').querySelector('.error') == null) {
				fieldName.closest('.form__box').prepend(error);
			}
			if (status === 0) {
				// eslint-disable-next-line no-param-reassign
				fieldName.closest('.form__box').querySelector('.error').innerHTML = i18next.t('empty_field');
				fieldName.closest('.form__box').classList.add('form__box_error');
				fieldName.closest('.form__box').classList.remove('form__box_valid');
				return false;
			}
			if (fieldName.closest('.form__box').querySelector('.error') !== null) {
				fieldName.closest('.form__box').querySelector('.error').remove();
			}
			fieldName.closest('.form__box').classList.remove('form__box_error');
			fieldName.closest('.form__box').classList.add('form__box_valid');
			return true;
		}

		const status = fieldName.value;
		const error = generateError('');
		if (fieldName.parentElement.querySelector('.error') == null) {
			fieldName.parentElement.prepend(error);
		}
		if (status.length <= 0) {
			// eslint-disable-next-line no-param-reassign
			fieldName.parentElement.querySelector('.error').innerHTML = i18next.t('empty_field');
			fieldName.parentElement.classList.add('form__box_error');
			fieldName.parentElement.classList.remove('form__box_valid');
			return false;
		}
		if (fieldName.parentElement.querySelector('.error') !== null) {
			fieldName.parentElement.querySelector('.error').remove();
		}
		fieldName.parentElement.classList.remove('form__box_error');
		fieldName.parentElement.classList.add('form__box_valid');
		return true;
	}));
}

function validateFields() {
	// eslint-disable-next-line no-unused-vars
	function validateConfirmPass(data, dataPass) {
		if (data === dataPass) {
			return true;
		}
		return false;
	}

	fields.filter((field) => field.forEach((fieldName) => {
		if (fieldName.getAttribute('name') === 'email') {
			fieldName.addEventListener('focus', function () {
				const status = this.value;
				if (status.length <= 0) {
					this.parentElement.classList.remove('form__box_error');
					this.parentElement.classList.remove('form__box_valid');
				}
			});
			fieldName.addEventListener('blur', function () {
				const status = this.value;
				const error = generateError('');
				if (this.parentElement.querySelector('.error') == null) {
					this.parentElement.prepend(error);
				}
				if (status.length <= 0) {
					this.parentElement.classList.remove('form__box_valid');
				} else if (!validateEmail(status)) {
					this.parentElement.querySelector('.error').innerHTML = i18next.t('wrong_email');
					this.parentElement.classList.add('form__box_error');
					this.parentElement.classList.remove('form__box_valid');
				} else {
					if (this.parentElement.querySelector('.error') !== null) {
						this.parentElement.querySelector('.error').remove();
					}
					this.parentElement.classList.remove('form__box_error');
					this.parentElement.classList.add('form__box_valid');
				}
			});
		} else if (fieldName.getAttribute('name') === 'agree' || fieldName.getAttribute('name') === 'checkbox') {
			fieldName.addEventListener('click', function () {
				const status = this;
				const error = generateError('');
				if (this.parentElement.querySelector('.error') == null) {
					this.parentElement.prepend(error);
				}
				if (!status.checked === true) {
					this.parentElement.querySelector('.error').innerHTML = i18next.t('privacy_policy');
					this.parentElement.classList.add('form__box_error');
					this.parentElement.classList.remove('form__box_valid');
				} else {
					if (this.parentElement.querySelector('.error') !== null) {
						this.parentElement.querySelector('.error').remove();
					}
					this.parentElement.classList.remove('form__box_error');
					this.parentElement.classList.add('form__box_valid');
				}
			});
		} else if (fieldName.getAttribute('name') === 'phone') {
			fieldName.addEventListener('focus', function () {
				const status = this.value;
				if (status.length <= 0) {
					this.parentElement.classList.remove('form__box_error');
					this.parentElement.classList.remove('form__box_valid');
				}
			});
			fieldName.addEventListener('blur', function () {
				const status = this.value;
				const error = generateError('');
				if (this.parentElement.querySelector('.error') == null) {
					this.parentElement.prepend(error);
				}
				if (status.length <= 0) {
					this.parentElement.classList.remove('form__box_valid');
				} else if (status.length < 19) {
					this.parentElement.querySelector('.error').innerHTML = i18next.t('wrong_tel');
					this.parentElement.classList.add('form__box_error');
					this.parentElement.classList.remove('form__box_valid');
				} else {
					if (this.parentElement.querySelector('.error') !== null) {
						this.parentElement.querySelector('.error').remove();
					}
					this.parentElement.classList.remove('form__box_error');
					this.parentElement.classList.add('form__box_valid');
				}
			});
		} else if (fieldName.getAttribute('name') === 'select' || fieldName.getAttribute('name') === 'order_type_id') {
			fieldName.addEventListener('focus', function() {
				const status = this.selectedIndex;
				if (status.length <= 0 || status === 0) {
					this.closest('.form__box').classList.remove('form__box_error');
					this.closest('.form__box').classList.remove('form__box_valid');
				}
			});
			fieldName.addEventListener('change', function() {
				const status = this.selectedIndex;
				const error = generateError('');
				if (this.closest('.form__box').querySelector('.error') == null) {
					this.closest('.form__box').prepend(error);
				}
				if (status.length <= 0 || status === 0) {
					this.closest('.form__box').classList.remove('form__box_valid');
				} else {
					if (this.closest('.form__box').querySelector('.error') !== null) {
						this.closest('.form__box').querySelector('.error').remove();
					}
					this.closest('.form__box').classList.remove('form__box_error');
					this.closest('.form__box').classList.add('form__box_valid');
				}
			});
		} else {
			fieldName.addEventListener('focus', function () {
				const status = this.value;
				if (status.length <= 0) {
					this.parentElement.classList.remove('form__box_error');
					this.parentElement.classList.remove('form__box_valid');
				}
			});
			fieldName.addEventListener('blur', function () {
				const status = this.value;
				const error = generateError('');
				if (this.parentElement.querySelector('.error') == null) {
					this.parentElement.prepend(error);
				}
				if (status.length <= 0) {
					this.parentElement.classList.remove('form__box_valid');
				} else {
					if (this.parentElement.querySelector('.error') !== null) {
						this.parentElement.querySelector('.error').remove();
					}
					this.parentElement.classList.remove('form__box_error');
					this.parentElement.classList.add('form__box_valid');
				}
			});
		}
	}));

	for (const field of form) {
		field.addEventListener('submit', function (e) {
			removeValidation();
			checkFields(this);

			let formFields = [];
			formFields = field.querySelectorAll('.js-field');

			for (const fieldControl of formFields) {
				if (!fieldControl.value) {
					e.preventDefault();
				}
			}
		});
	}
}
